module.exports = __webpack_public_path__ + "img/spring.fd16c95e.png";